import React from 'react'

interface DeviceUserCardProps {
  children: React.ReactNode
  title?: string
}

export default function DeviceUserCard({ children, title }: DeviceUserCardProps) {
  return (
    <div className="w-[500px] bg-white shadow-md p-14">
      <div className="w-[388px] mx-auto">
        {title && (
          <h2 className="text-2xl font-semibold text-gray-900 mb-5 text-center">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  )
}
